export default {
  SET_RESERVATION_STEP(state, step) {
    state.reservationStep = step
  },
  SET_RESERVATION_SELECTED_SPOTS(state, spots) {
    state.reservationSelectedSpots = spots
  },
  SET_RESERVATION_SERVICE_ID(state, serviceId) {
    state.reservationServiceId = serviceId
  },
  SET_RESERVATION_TUTOR_ID(state, tutorId) {
    state.reservationTutorId = tutorId
  },
  SET_RESERVATION_LOCATION(state, location) {
    state.reservationLocation = location
  },
  SET_RESERVATION_PARAMETERS_CONFIRMED(state, confirmed) {
    state.reservationParametersConfirmed = confirmed
  },
  RESET_RESERVATION_FLOW(state) {
    state.reservationStep = 1
    state.reservationSelectedSpots = []
    state.reservationServiceId = null
    state.reservationTutorId = null
    state.reservationLocation = null
    state.reservationParametersConfirmed = false
  },
}
